import { VStack } from '@bpba/ui-components';
import { FC, ReactNode } from 'react';
import { StyledErrorIcon } from '../components/shared/StyledErrorIcon';
import { WARNING_CONTAINER_ICON_SIZE } from '../constants/dimensions';
import { StyledBox } from '../components/shared/StyledBox';

type Props = {
  children: ReactNode;
};

/**
 * Componente contenedor para mostrar advertencias.
 */
export const GenericWarningContainer: FC<Props> = ({ children }) => {
  return (
    <StyledBox flexDirection={['column', 'row']} alignItems="center" mt={['24px']} lineHeight={'24px'} fontSize={'13px'}>
      <StyledErrorIcon size={WARNING_CONTAINER_ICON_SIZE} aria-hidden="true" />
      <VStack width="fit-content" role="alert" tabIndex={0} textAlign={'justify'}>
        {children}
      </VStack>
    </StyledBox>
  );
};
